import { enableMaintenance } from "./maintenance";

export async function handleMaintenanceResponse(resp: Response) {
  if (resp.status === 503) {
    try {
      const data = await resp.clone().json();
      if (data?.maintenance) {
        enableMaintenance();
        window.location.href = "/maintenance";
        return true;
      }
    } catch {}
  }
  return false;
}

export function handleNetworkError() {
  enableMaintenance();
  window.location.href = "/maintenance";
}
